import React from 'react';
import intl from "react-intl-universal";
import {observer} from 'mobx-react-lite'
import classNames from "classnames";
import {useRootStore, useDsManager, useAppState} from "@stores/AppStateContext";

import {PersonAdd} from "../../components/icons/PersonAdd";
import {UpgradePlanButton} from "../typesOfButtons/UpgradePlanButton"
import {BackIcon} from "../../components/icons/BackIcon";
import {Button} from "../../components/Button";
import {inviteUser} from "../../../actions/invite";
import {NotificationButton} from "../context-menu/NotificationPanel/NotificationButton"
import {ProfileIcon} from "../RightMenu/ProfileIcon";
import {PAGES} from "../../../stores/ViewStore";

import {pageAdditionalParamsRef} from "../../../volatile/pageAdditionalParams";
import {screenSizeProvider} from "../../../stores/ScreenSizeProvider";
import {isFreePlan} from "../../../stores/client";

import './header-menu.css';

export const getPageTitle = (page: string) => {
    switch (page) {
        case PAGES.KNOWLEDGE_BASE:
        case PAGES.DOC_EDIT:
        case PAGES.DOC_HISTORY:
            return intl.get('headerMenu.knowledge').d('Knowledge Base');
        case PAGES.SETTINGS_GENERAL:
            return intl.get('menu_settings.general_settings').d('Company General Settings');
        case PAGES.SETTINGS_MEMBERS:
            return intl.get('menu_settings.general_members').d('Company Members');
        case PAGES.SETTINGS_BILLING:
            return intl.get('menu_settings.plansAndBillings').d('Plans & Billing');
        case PAGES.WORKSPACE_SETTINGS_GENERAL:
            return intl.get('workspace.menu_settings.settings').d('Workspace General Settings');
        case PAGES.WORKSPACE_MEMBERS:
            return intl.get('workspace.menu_settings.members').d('Workspace Members');
        case PAGES.QUIZZES:
        case PAGES.QUIZ_VIEW:
        case PAGES.QUIZ_EDIT:
        case PAGES.QUIZ_TAKE:
            return intl.get('menu_settings.tests').d('Tests');
        case PAGES.ACKNOWLEDGMENTS_OVERVIEW:
            return intl.get('menu_settings.acknowledgments.overview').d('Acknowledgments Overview');
        case PAGES.LISTS:
            return intl.get('settings-menu.recurring-tasks').d('Recurring Tasks');
        case PAGES.CHARTFLOW:
            return intl.get('menu_settings.chartflow').d('Chartflow');
        case PAGES.SETTINGS_PROFILE:
            return intl.get('profile.header').d('Profile');
        default:
            return '';
    }
}

export const HeaderMenu = observer(() => {
    const appState = useAppState();
    const rootStore = useRootStore();
    const dsManager = useDsManager();
    const isMobile = screenSizeProvider.view !== 'desktop';
    const invitePeople = intl.get('headerMenu.invite_people').d('Invite people')
    const title = getPageTitle(rootStore.view.page);
    const clientSubscriptionPlan = dsManager?.clientAR?.row?.subscription_plan;
    const shouldShowUpgradeButton = isFreePlan(clientSubscriptionPlan);

    let currentBackCb = pageAdditionalParamsRef.current?.back;

    return (
        <header className={classNames({
            "hm": true,
            "theme-dark": isMobile
        })}>
            <div className='hm_sb title-medium-bold'>
                {
                    currentBackCb
                        ? (
                            <BackIcon
                                additionalPadding={isMobile ? 12 : undefined}
                                className={"Quizzes__BackIcon"}
                                onClick={currentBackCb}/>
                        )
                        : null
                }
                <span className="title-large-bold hm-title">
                    {title}
                </span>
            </div>
            <div className='hm_button'>
                <Button
                    type='neutral'
                    style='soft'
                    Icon={PersonAdd}
                    size="md"
                    text={
                        !isMobile ? invitePeople : null
                    }
                    onClick={() => inviteUser(dsManager!, appState)}
                />
            </div>
            {
                shouldShowUpgradeButton ? (
                    <UpgradePlanButton contentType={!isMobile ? "iconWithFullText" : "icon"} className={"hm_button"}/>
                ) : null
            }
            <NotificationButton className={"hm_button"}/>
            <ProfileIcon 
                className="hm_button" 
                size={24}
            />
        </header>
    );
});
